import { Component, } from '@angular/core';
import { IValueChange } from '../../../core/interfaces/form-value-change.interface';
import { ProfileFormTemplateProviders } from '../../../core/templates/profile-form.template.providers';
import { AbstractProfileFormComponent } from "../../abstract/abstract-profile/abstract-profile-form.component";
import { BFOnFormLoadComplete, BFOnValueChange } from "../../../core/interfaces/sdk-profile-hooks.interface";
import { Representment } from "../../models/representment.model";
import { ProfileLayoutType } from "../../enums/profile-layout-type.enum";

@Component({
  selector: 'app-representment',
  templateUrl: '../../../core/templates/profile-form.template.html',
  styleUrls: ['../../../core/templates/profile-form.template.scss'],
  providers: ProfileFormTemplateProviders
})
export class RepresentmentComponent extends AbstractProfileFormComponent implements BFOnValueChange, BFOnFormLoadComplete {

  fgppFormLoadComplete(): void {
    this.handleCalculationFirstRow();
    let maxRepresentment = this.formMgr.get(Representment.MAX_REPRESENTMENTS).getValue();
    if (this.layoutMode === ProfileLayoutType.CREATE || maxRepresentment == 1) {
      this.disableSecondRow();
    } else if (this.layoutMode === ProfileLayoutType.EDIT) {
      this.handleCalculationSecondRow()
    }
  }

  fgppValueChanges(change: IValueChange): void {

    if (change.control === Representment.MAX_REPRESENTMENTS) {
      this.handleMaxRepresentmentChange(change);
      return;
    }
    this.handleCalculationFirstRow();
    this.handleCalculationSecondRow();

  }

  handleCalculationFirstRow() {
    let adjDateValue = this.formMgr.get(Representment.FIRST_VALUE_DATE_ADJUSTMENT).getValue();
    if (!adjDateValue) {
      this.formMgr.get(Representment.FIRST_CYCLE_TYPE).disable();
      this.formMgr.get(Representment.FIRST_NUMBER_OF_DAYS).disable();
      this.formMgr.get(Representment.FIRST_CYCLE_TYPE).reset();
      this.formMgr.get(Representment.FIRST_NUMBER_OF_DAYS).reset();
    } else if (adjDateValue === 'Number of days') {
      if (this.layoutMode !== ProfileLayoutType.VIEW) {
        this.formMgr.get(Representment.FIRST_NUMBER_OF_DAYS).enable();
      }
      this.formMgr.get(Representment.FIRST_NUMBER_OF_DAYS).markAsRequired();
      this.formMgr.get(Representment.FIRST_CYCLE_TYPE).disable();
      this.formMgr.get(Representment.FIRST_DAY_OF_WEEK).disable();
      this.formMgr.get(Representment.FIRST_CYCLE_TYPE).reset();
      this.formMgr.get(Representment.FIRST_DAY_OF_WEEK).reset();
      this.formMgr.get(Representment.FIRST_CYCLE_TYPE).markAsOptional();
      this.formMgr.get(Representment.FIRST_DAY_OF_MONTH).markAsOptional();
    } else {// Schedual
      if (this.layoutMode !== ProfileLayoutType.VIEW) {
        this.formMgr.get(Representment.FIRST_CYCLE_TYPE).enable();
      }
      this.formMgr.get(Representment.FIRST_CYCLE_TYPE).markAsRequired();
      this.formMgr.get(Representment.FIRST_NUMBER_OF_DAYS).disable();
      this.formMgr.get(Representment.FIRST_NUMBER_OF_DAYS).reset();
      this.formMgr.get(Representment.FIRST_NUMBER_OF_DAYS).markAsOptional();
    }

    let cycleType = this.formMgr.get(Representment.FIRST_CYCLE_TYPE).getValue();
    if (!cycleType) {
      this.formMgr.get(Representment.FIRST_DAY_OF_WEEK).disable();
      this.formMgr.get(Representment.FIRST_DAY_OF_MONTH).disable();
      this.formMgr.get(Representment.FIRST_DAY_OF_WEEK).reset();
      this.formMgr.get(Representment.FIRST_DAY_OF_MONTH).reset();
    } else if (cycleType === 'Weekly') {
      if (this.layoutMode !== ProfileLayoutType.VIEW) {
        this.formMgr.get(Representment.FIRST_DAY_OF_WEEK).enable();
      }
      this.formMgr.get(Representment.FIRST_DAY_OF_WEEK).markAsRequired();
      this.formMgr.get(Representment.FIRST_DAY_OF_MONTH).disable();
      this.formMgr.get(Representment.FIRST_DAY_OF_MONTH).reset();
      this.formMgr.get(Representment.FIRST_DAY_OF_MONTH).markAsOptional();
    } else {
      if (this.layoutMode !== ProfileLayoutType.VIEW) {
        this.formMgr.get(Representment.FIRST_DAY_OF_MONTH).enable();
      }
      this.formMgr.get(Representment.FIRST_DAY_OF_MONTH).markAsRequired();
      this.formMgr.get(Representment.FIRST_DAY_OF_WEEK).disable();
      this.formMgr.get(Representment.FIRST_DAY_OF_WEEK).reset();
      this.formMgr.get(Representment.FIRST_DAY_OF_WEEK).markAsOptional();
    }
  }

  handleCalculationSecondRow() {
    let maxRepresentment = this.formMgr.get(Representment.MAX_REPRESENTMENTS).getValue();
    if (maxRepresentment === '2') {
      this.formMgr.get(Representment.SUBSEQUENT_VALUE_DATE_ADJ).enable();
      this.formMgr.get(Representment.SUBSEQUENT_VALUE_DATE_ADJ).markAsRequired();
    }
    let adjDateValue = this.formMgr.get(Representment.SUBSEQUENT_VALUE_DATE_ADJ).getValue();
    if (!adjDateValue) {
      this.formMgr.get(Representment.SUBSEQUENT_CYCLE_TYPE).disable();
      this.formMgr.get(Representment.SUBSEQUENT_NUMBER_OF_DAYS).disable();
      this.formMgr.get(Representment.SUBSEQUENT_CYCLE_TYPE).reset();
      this.formMgr.get(Representment.SUBSEQUENT_NUMBER_OF_DAYS).reset();
    } else if (adjDateValue === 'Number of days') {
      this.formMgr.get(Representment.SUBSEQUENT_NUMBER_OF_DAYS).enable();
      this.formMgr.get(Representment.SUBSEQUENT_NUMBER_OF_DAYS).markAsRequired();
      this.formMgr.get(Representment.SUBSEQUENT_CYCLE_TYPE).disable();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).disable();
      this.formMgr.get(Representment.SUBSEQUENT_CYCLE_TYPE).reset();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).reset();
      this.formMgr.get(Representment.SUBSEQUENT_CYCLE_TYPE).markAsOptional();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).markAsOptional();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_MONTH).markAsOptional();
    } else {// Schedual
      this.formMgr.get(Representment.SUBSEQUENT_CYCLE_TYPE).enable();
      this.formMgr.get(Representment.SUBSEQUENT_CYCLE_TYPE).markAsRequired();
      this.formMgr.get(Representment.SUBSEQUENT_NUMBER_OF_DAYS).disable();
      this.formMgr.get(Representment.SUBSEQUENT_NUMBER_OF_DAYS).reset();
    }

    let cycleType = this.formMgr.get(Representment.SUBSEQUENT_CYCLE_TYPE).getValue();
    if (!cycleType) {
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).disable();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_MONTH).disable();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).reset();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_MONTH).reset();
    } else if (cycleType === 'Weekly') {
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).enable();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).markAsRequired();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_MONTH).disable();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_MONTH).reset();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_MONTH).markAsOptional();
    } else {
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_MONTH).enable();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_MONTH).markAsRequired();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).disable();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).reset();
      this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).markAsOptional();
    }
  }

  disableSecondRow() {
    this.formMgr.get(Representment.SUBSEQUENT_VALUE_DATE_ADJ).disable();
    this.formMgr.get(Representment.SUBSEQUENT_NUMBER_OF_DAYS).disable();
    this.formMgr.get(Representment.SUBSEQUENT_CYCLE_TYPE).disable();
    this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_MONTH).disable();
    this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).disable();

    this.formMgr.get(Representment.SUBSEQUENT_VALUE_DATE_ADJ).reset();
    this.formMgr.get(Representment.SUBSEQUENT_NUMBER_OF_DAYS).reset();
    this.formMgr.get(Representment.SUBSEQUENT_CYCLE_TYPE).reset();
    this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_MONTH).reset();
    this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).reset();

    this.formMgr.get(Representment.SUBSEQUENT_VALUE_DATE_ADJ).markAsOptional();
    this.formMgr.get(Representment.SUBSEQUENT_NUMBER_OF_DAYS).markAsOptional();
    this.formMgr.get(Representment.SUBSEQUENT_CYCLE_TYPE).markAsOptional();
    this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_MONTH).markAsOptional();
    this.formMgr.get(Representment.SUBSEQUENT_DAY_OF_WEEK).markAsOptional();
  }

  handleMaxRepresentmentChange(change: IValueChange) {
    if (change.value.inputValue) {
      this.formMgr.get(Representment.FIRST_VALUE_DATE_ADJUSTMENT).enable();
      if (change.value.inputValue === '1') {
        this.handleCalculationFirstRow();
        this.disableSecondRow();
      } else {
        this.handleCalculationSecondRow();
      }
    } else {
      this.formMgr.get(Representment.FIRST_VALUE_DATE_ADJUSTMENT).disable().reset();
      this.formMgr.get(Representment.SUBSEQUENT_VALUE_DATE_ADJ).disable().reset();
}

  }

}
